import React from 'react'
import styled, { keyframes, css } from 'styled-components'
import { mediaMax, mediaMin } from 'frontend_core/dist/styles/media'
import {
  zIndexes,
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import Colors from 'frontend_core/dist/styles/colors'
const Baloon = styled.div`
  position: relative;
  display: block;
  width: 100%;
  margin-top: 4px;
  background-color: ${Colors.white};
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  border-radius: ${borderRadius}px;
  z-index: ${zIndexes.baloon};

  &::before {
    position: absolute;
    top: -7px;
    left: ${props =>
      props.beakHorizontalPosition ? props.beakHorizontalPosition : '50%'};
    width: 15px;
    height: 15px;
    background-color: ${Colors.white};
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    transform: rotate(45deg);
    content: '';
    ${mediaMax.phone`
      top: -6px;
      left: ${props => props.beakHorizontalPositionSp};
      height: 12px;
      width: 12px;
    `} ${({ isTop }) =>
      isTop &&
      css`
        top: auto;
        bottom: -7px;
        ${mediaMax.phone`
        top: auto;
        bottom: -6px;
      `};
      `};
  }
`

const BaloonInner = styled.div`
  display: block;
  padding: ${spacing.small_3}px;
  color: ${Colors.black};
  font-size: ${fontSize.small}px;
  font-weight: bold;
  line-height: 1.4;
  background-color: ${Colors.white};
  border-radius: ${borderRadius}px;
  transform: rotate(0deg);
  ${mediaMax.phone`
    padding: ${spacing.small_2}px;
  `};
`

const PlanTooltipDown = keyframes`
  0% {
    top: 15px;
    opacity: 0;
  }

  100% {
    top: 25px;
    opacity: 1;
  }
`

const PlanTooltipUp = keyframes`
  0% {
    top: auto;
    bottom: 15px;
    opacity: 0;
  }

  100% {
    top: auto;
    bottom: 25px;
    opacity: 1;
  }
`

const ToolTipContent = styled.div`
  position: absolute;
  display: none;
  top: 25px;
  width: 240px;
  ${mediaMin.phone`
  `}
  ${({ ToolTipWidth }) =>
    ToolTipWidth &&
    css`
      width: ${ToolTipWidth};
    `}
  ${({ right }) =>
    right &&
    css`
      right: ${right};
    `}
  ${({ left }) =>
    left &&
    css`
      left: ${left};
    `}
  ${({ isTop }) =>
    isTop &&
    css`
      top: auto;
      bottom: 25px;
    `}
`

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  font-size: ${fontSize.small_2}px;
  cursor: help;

  &:hover {
    ${ToolTipContent} {
      /* stylelint-disable-line */
      display: block;
      animation: ${PlanTooltipDown} 0.25s 1;
      ${({ isTop }) =>
        isTop &&
        css`
          animation: ${PlanTooltipUp} 0.25s 1;
        `};
    }
  }
`

export default (props: Object) => (
  <TooltipWrapper ToolTipWidth={props.ToolTipWidth} isTop={props.isTop}>
    {props.children}
    <ToolTipContent right={props.right} left={props.left} isTop={props.isTop}>
      <Baloon {...props}>
        <BaloonInner>{props.text}</BaloonInner>
      </Baloon>
    </ToolTipContent>
  </TooltipWrapper>
)
